import request from '@/utils/request'

/**
 * 获取所有角色
 */
export const getRoleList = (data) => {
  return request({
    url: '/sys/v1/role',
    method: 'GET',
    params: data
  })
}

/**
 * 获取角色分页
 * @param {*} params
 */
export const rolePage = (params) => {
  return request({
    url: '/sys/v1/role/page',
    method: 'GET',
    params
  })
}

/**
 * 获取指定角色的权限
 */
export const rolePermission = (roleId) => {
  return request({
    url: `/sys/v1/permission/role-id/${roleId}`
  })
}

/**
 * 为角色修改权限
 */
export const distributePermission = (data) => {
  return request({
    url: '/sys/v1/role/role-permission',
    method: 'POST',
    data
  })
}

/**
 * 新增权限
 */
export const addRole = (data) => {
  return request({
    url: '/sys/v1/role',
    method: 'POST',
    data
  })
}

/**
 * 修改权限
 */
export const updateRole = (data) => {
  return request({
    url: '/sys/v1/role',
    method: 'PUT',
    data
  })
}

/**
 * 新增权限
 */
export const delRole = (id) => {
  return request({
    url: `/sys/v1/role/${id}`,
    method: 'DELETE'
  })
}

/**
 * 新增租户和角色的关系
 * @param {*} data
 * @return
 */
export const TenantRole = (data) => {
  return request({
    url: '/sys/v1/role/tenant-role',
    method: 'POST',
    data
  })
}
